import React from "react";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import CONFIG from "../../utils/config";
import AssignedUserList from "./AssignedUserList";
import {  SessionKeys,clickStreamUser } from "../../utils/AppUtils";
import { loginIframeUserResponse } from "../../redux/auth/actions";
import { setIframeUserRole } from "../../redux/user/actions";
import $ from "jquery";
import Loader from "../../components/Loader/Loader";
import _ from "lodash";


const AssignedUserListMobile = () => {
  const dispatch = useDispatch();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const token = params.get("token");
  const key = params.get("key");
  const username = params.get("username");
  const user_id = params.get("user_id");
  const color_1 = params.get("color_1");
  const color_2 = params.get("color_2");
  const role = params.get("role");

  const [isLoading, setIsLoading] = useState(true);
  const [isValidKey, setIsValidKey] = useState(false);

  useEffect(() => {
    if (document.getElementById("id_page_404") !== null) {
      document.getElementById("id_page_404").style.display = "none";
    }
  }, []);

  useEffect(() => {
    if (key === CONFIG.KEY.MOBILE_ACCESS_KEY) {
      $("html").css(
        "--color-element-1",
        color_1 ? "#" + color_1 : CONFIG.COLOR_ELEMENT_1
      );
      $("html").css(
        "--color-element-2",
        color_2 ? "#" + color_2 : CONFIG.COLOR_ELEMENT_2
      );
      localStorage.setItem(SessionKeys.API_TOKEN, token);
      localStorage.setItem(SessionKeys.USERNAME, username);
      setIsValidKey(true);
      if (role === "pmpro_membership_manager") {
        dispatch(setIframeUserRole("broker"));
      } else if (role === "broker_admin") {
        dispatch(setIframeUserRole("admin"));
      }

      setIsLoading(true);
      dispatch(
        loginIframeUserResponse({
          payload: {
            user: {
              user_id: user_id,
              username: username,
              email: username,
              role: [role],
            },
            apiToken: token,
          },
        })
      );

      clickStreamUser("coaching_detail_mobile_page", {
        userId: user_id,
      });
      setIsLoading(false);
    }
  }, [token, key, user_id, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Loader start={isLoading} />
      {isValidKey ? (
        <>
          <AssignedUserList isMobile={true} />
        </>
      ) : (
        <div>Invalid Key</div>
      )}
    </>
  );
};

export default AssignedUserListMobile;
